import { render } from "./abbreviation.vue?vue&type=template&id=404e281e"
import script from "./abbreviation.vue?vue&type=script&lang=js"
export * from "./abbreviation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__